import * as Sentry from '@sentry/browser';

const makeSentrySettings = () => ({
  dsn: window.SENTRY_DSN,
  beforeSend(event, hint) {
    const exceptionMessage = hint?.originalException?.message || '';

    if (exceptionMessage.match(/JSON Parse error: Unexpected identifier/i)) {
      return null;
    }
    return event;
  },
  ignoreErrors: [
    // Network errors such as going offline or being blocked by a proxy
    'TypeError: Failed to fetch',
    'TypeError: Load failed',
    'TypeError: NetworkError when attempting to fetch resource.',
    'TypeError: Cancelled',
    'TypeError: cancelled',
    'Error: load error',
    'SecurityError: Blocked a frame with origin "https://www.brilliant.tech" from accessing a cross-origin frame',
    // Shopify uses Bugsnag for tracking errors
    'Failed to load bugsnag',
    // Shopify load balancing system errors
    'Monorail Edge',
    // Errors coming from Microsoft
    'Non-Error promise rejection captured',
    // Random plugins/extensions
    'top.GLOBALS',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
  ],
  denyUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    // Ignore Google flakiness
    /\/(gtm|ga|gtag|analytics)\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    // Safari webkit
    /webkit-masked-url:\/\/hidden/i,
    // Klaviyo
    /klaviyo\.com\/onsite\/js\/signup_forms/i,
    // Instagram
    /instagram\.com/i,
    // LinkedIn
    /linkedin\.com/i,
    // Facebook
    /facebook\.com/i,
    // Edge
    /edge\.com/i,
  ],
  allowUrls: [/^https?:\/\/(www\.)?brilliant\.tech\//i],
});

const initSentry = () => {
  window.SentryHelper = {
    captureException(err, message) {
      Sentry.withScope((scope) => {
        if (message && typeof message === 'string') {
          scope.setTag('message', message);
        }
        Sentry.captureException(err);
      });
    },
    captureMessage(message) {
      Sentry.captureMessage(message);
    },
  };

  Sentry.init(makeSentrySettings());
};

initSentry();
